import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IonicSafeString, ModalController } from '@ionic/angular';
import { Contest } from 'src/app/models/contest';

@Component({
  selector: 'app-custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.scss'],
})
export class CustomErrorAlertComponent implements AfterViewInit {

  @Input() contest?: Contest;
  @Input() notRecognizedFields!: string;
  message!: SafeHtml;
  @Output() back = new EventEmitter<void>();

  constructor(private modalCtrl: ModalController, private sanitizer: DomSanitizer) {
    // console.trace('CustomErrorAlertComponent creado');
  }
  ngAfterViewInit(): void {
    console.log("this.notRecognizedFields", this.notRecognizedFields);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  get canEditFields() {
    if (!this.contest || this.contest.manual_validation === false) return false;
    return true;
  }

  get fieldsCount(): number {
    if (!this.notRecognizedFields) {
      return 0;
    }

    return (this.notRecognizedFields.match(/<li>/g) || []).length;
  }

  get notRecognizedFieldsList(): string[] {
    return this.notRecognizedFields
      ?.match(/<li>(.*?)<\/li>/g)
      ?.map(item => item.replace(/<\/?li>/g, '').trim()) ?? [];
  }

  goBack() {
    console.log('Custom alert back');
    this.modalCtrl.dismiss();
    this.back.emit();
  }
}
